<template>
  <div class="userinfo">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" />
    <form-entity :model="user" :rules="rules" class="form-edit">
      <form-field
        prop="nickName"
        :default-focus="false"
        :options="{
          label: '用户昵称',
          readonly: true,
          placeholder: '用户昵称',
          type: 'text',
          required: true
        }"
      />
      <form-field
        prop="userId"
        :default-focus="true"
        :options="{
          label: '用户ID',
          readonly: true,
          placeholder: '用户ID',
          type: 'text',
          required: true
        }"
      />
      <form-field
        prop="mobileNumber"
        :options="{
          label: '手机号码',
          readonly: true,
          placeholder: '手机号码',
          type: 'tel',
          format: 'phone',
          required: true
        }"
      />
    </form-entity>
    <img v-if="!type" class="qrcode" :src="qrcode" alt="" />
    <h5 v-if="!type">添加班主任微信，激活课程服务</h5>
    <!-- 合并账号提示 -->
    <img v-if="type" class="qrcode" :src="popData.data.adviser.avatarUrl || ''" alt="" />
    <h5 v-if="type">{{ popData.message }}</h5>
    <!-- 只在浏览器访问 -->
    <!-- <div class="flexbox btns_box" v-if="user.channel === 'WEB'">
      <mt-button @click="clear">清除用户信息</mt-button>
    </div> -->
  </div>
</template>

<script>
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
export default {
  name: 'userinfo',
  data() {
    return {
      title: '学员信息',
      rules: {},
      type: null
    }
  },
  computed: {
    ...mapGetters('user/login', ['qrcode', 'popData']),
    user() {
      return appUser
    }
  },
  created() {
    this.type = this.$route.query.type || null
    var params = {}
    this.$store.dispatch('user/login/getUserDetail', params)
  },
  methods: {
    clear() {
      localStorage.clear()
      Toast('清除成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode {
  width: 2.8rem;
  height: 2.8rem;
  background: #ccc;
  display: block;
  margin: 1.6rem auto 0 auto;
  border: 1px solid #dddddd;
}
h5 {
  width: 100%;
  text-align: center;
  font-size: 0.28rem;
  font-weight: 600;
  color: #00b25a;
  line-height: 0.34rem;
  margin: 0.24rem 0 0.16rem 0;
}
p {
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.3rem;
  width: 100%;
  text-align: center;
}
.btns_box {
  width: 100%;
  margin-top: 10px;
  justify-content: space-around;
}
</style>
